/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Vue = require('vue');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

function mixins() {
  for (var _len = arguments.length, mixins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    mixins2[_key] = arguments[_key];
  }

  return Vue__default["default"].extend({
    mixins: mixins2
  });
}

exports["default"] = mixins;
//# sourceMappingURL=mixins.js.map
